import React from 'react';
import { Link } from 'react-router-dom';
import { Home, BookOpen, ArrowLeft } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="min-h-full bg-gray-50 flex items-center justify-center px-4">
      <div className="text-center max-w-lg">
        <div className="mb-8">
          <div className="text-8xl font-extrabold text-primary/20 select-none">404</div>
          <div className="w-24 h-1 bg-gradient-to-r from-primary to-secondary rounded-full mx-auto -mt-4 mb-6" />
          <h1 className="text-2xl font-bold text-gray-800 mb-3">Page non trouvée</h1>
          <p className="text-gray-500">
            Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
          <Link
            to="/"
            className="flex items-center justify-center gap-2 px-4 py-3 bg-primary text-white rounded-xl hover:bg-primary/90 transition-colors font-medium"
          >
            <Home className="w-4 h-4" />
            Accueil
          </Link>
          <Link
            to="/courses"
            className="flex items-center justify-center gap-2 px-4 py-3 border-2 border-primary text-primary rounded-xl hover:bg-primary/5 transition-colors font-medium"
          >
            <BookOpen className="w-4 h-4" />
            Voir les cours
          </Link>
        </div>

        <div className="text-sm text-gray-400 space-y-2">
          <p>Vous pouvez aussi accéder à :</p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/dashboard" className="text-primary hover:underline">Tableau de bord</Link>
            <span className="text-gray-300">·</span>
            <Link to="/about" className="text-primary hover:underline">À propos</Link>
            <span className="text-gray-300">·</span>
            <Link to="/terms" className="text-primary hover:underline">CGU</Link>
            <span className="text-gray-300">·</span>
            <Link to="/privacy" className="text-primary hover:underline">Confidentialité</Link>
          </div>
        </div>

        <button
          onClick={() => window.history.back()}
          className="mt-8 flex items-center gap-2 text-gray-400 hover:text-gray-600 transition-colors mx-auto text-sm"
        >
          <ArrowLeft className="w-4 h-4" />
          Retour à la page précédente
        </button>
      </div>
    </div>
  );
};

export default NotFound;
